import { render, staticRenderFns } from "./companyContactList.vue?vue&type=template&id=460d1070&scoped=true"
import script from "./companyContactList.vue?vue&type=script&lang=js"
export * from "./companyContactList.vue?vue&type=script&lang=js"
import style0 from "./companyContactList.vue?vue&type=style&index=0&id=460d1070&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d1070",
  null
  
)

export default component.exports